import { Component, OnInit } from '@angular/core';
import {MDBModalRef} from 'angular-bootstrap-md';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-upload-error-msg',
  templateUrl: './upload-error-msg.component.html',
  styleUrls: ['./upload-error-msg.component.scss']
})
export class UploadErrorMsgComponent implements OnInit {
  action = new Subject();
  message: string;
  constructor(public modalRef: MDBModalRef) { }

  ngOnInit() {

  }
  close() {
    this.action.next('OK');
  }

}
